<template>
  <div v-for="item in contenu"
    class="group px-6 py-8 bg-white dark:bg-slate-900 shadow hover:shadow-lg dark:hover:shadow-gray-800 duration-500 ease-in-out border-t-[3px] border-gray-100 dark:border-gray-700 hover:border-indigo-600 dark:hover:border-indigo-600">
    <button :class="{ 'text-selected': selectedText, 'text-normal': !selectedText, }" type="checkbox"><i
        :class="{ 'uil-check-circle': isActive }" class="uil text-indigo-600 text-2xl font-bold mr-2"></i> {{ item.mois }}
      mois</button>
    <div class="content mt-6">
      <button class="text-xl font-semibold hover:text-indigo-600 duration-500 ease-in-out">{{ item.qut }}  {{ item.type }}</button>
      <p class="text-slate-400 mt-4">Description de l'equipement</p>

      <div class="mt-5 flex align-content-center align-self-center">
        <i class="uil uil-money-bill text-indigo-600 text-xl"></i>
        <i class="uil uil-arrow-right text-indigo-600"></i>
        <p href=""
          class="btn btn-link text-lg font-bold text-indigo-600 hover:text-indigo-600 after:bg-indigo-600 duration-500 ease-in-out">
          {{ item.prix }} {{ Devises.af }}</p>
      </div>
    </div>
  </div><!--end content-->
</template>

<script>
import PackService from "@/services/modules/pack.service"
export default {

  data() {
    return {

      packPrice: 4750,
      Devises: {
        af: 'XOF',
        ac: 'XAF',
        e: '€',
        d: '$',
      },
      Pack: {
        nameFirst: 'QR LINK',
        nameSecond: 'Comptoir',
        nameThird: 'Stand Touch',
      },
      isActive: true,
      selectedText: true,
      packId: '',
      contenu: []
    }
  },

  beforeMount() {
    this.packId = this.$route.params.id
   
  },

  mounted() {
    this.getPackSelected()
  },
  methods: {
    selectedPlan() {
      this.isActive = !this.isActive;
      this.selectedText = !this.selectedText;
    },
    getPackSelected() {

      PackService.getOnePack(this.packId).then(response => {

        let selected = response.data.data


        this.contenu = selected.contenue


       

      }).catch(e => { }

      )
    },
  }
}
</script>

<style scoped>
.text-selected {
  font-size: large;
  color: rgb(79 70 229);
  font-weight: 800;
}
</style>